<template>
	<div class="widget-editor-table-mapper hover-btn-effect flex-centerize">Configure your table mapper on the right</div>
</template>

<script>
export default {
	name: 'WidgetEditorTableMapper',
};
</script>

<style scoped lang="scss">
.widget-editor-table-mapper {
	height: 30vh;
}
</style>
